import { Direction } from "odyssey-shared";

/**
 * The movement intent of a page with a stick: the stick's direction while it sends one, otherwise the keys'.
 *
 * @param stick The stick.
 * @param keys Reads the direction the keys hold.
 * @returns The intent.
 */
export function stickOr(stick: { direction(): Direction }, keys: () => Direction): Direction {
  const pushed = stick.direction();
  return pushed === Direction.None ? keys() : pushed;
}
